import BranchTable from "./branchTable.container";

export default BranchTable;